module.exports = "<div [ngStyle]=\"styles\" *ngIf=\"show\">\r\n  <div class=\"progress-bar progress-bar-striped active\"\r\n       role=\"progressbar\"\r\n       aria-valuenow=\"45\"\r\n       aria-valuemin=\"0\"\r\n       aria-valuemax=\"100\"\r\n       style=\"width: 100%\">\r\n  </div>\r\n</div>\r\n\r\n\r\n\r\n\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/strippedProgressBar/strippedProgressBar.component.html
// module id = ./src/app/shared/components/strippedProgressBar/strippedProgressBar.component.html
// module chunks = main